/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface LpInspectionControllerSearchAll$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 결과
 */
  result?: (Array<'\uC801\uD569' | '\uBD80\uC801\uD569' | '\uC9C0\uC18D \uAD00\uCC30' | '\uC815\uC0C1 \uBC1C\uB2EC' | '\uC0C1\uB2F4 \uAD8C\uACE0'>) | null;

/**
 * 완료 여부
 */
  isCompleted?: boolean | null;

/**
 * 카테고리
 */
  category?: string | null;

/**
 * 결제 방법
 */
  paymentMethod?: (Array<'\uCFE0\uD3F0' | '\uC2E4 \uACB0\uC81C'>) | null;

/**
 * 성별
 */
  gender?: ('MALE' | 'FEMALE') | null;

/**
 * 센터 ID
 */
  centerId?: string | null;

/**
 * 아동 ID
 */
  childId?: string | null;

/**
 * 부모 회원 ID (검사자)
 */
  parentUserId?: string;

/**
 * 비회원 여부
 */
  isNonMember?: boolean | null;

/**
 * 회원 여부
 */
  isMember?: boolean | null;

/**
 * 세그먼트
 */
  segment?: string | null;

/**
 * 타입 목록
 */
  types?: Array<string>;

/**
 * 검사 상태 목록
 */
  statuses?: Array<string>;

/**
 * 담당 선생님 목록
 */
  teachers?: Array<string>;

/**
 * 적합/부적합 목록
 */
  validInvalids?: Array<string>;

/**
 * 아동ID 목록
 */
  children?: Array<string>;

/**
 * 회원 역할
 */
  memberRole?: ('PARENT' | 'TEACHER') | null;

/**
 * 나이 필터링
 */
  age?: number | null;

/**
 * 나이 필터링
 */
  highAge?: number | null;

/**
 * 나이 필터링 타입
 */
  ageType?: ('just' | 'until') | null;
}

export function lpInspectionControllerSearchAll(http: HttpClient, rootUrl: string, params: LpInspectionControllerSearchAll$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionControllerSearchAll.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('result', params.result, {});
    rb.query('isCompleted', params.isCompleted, {});
    rb.query('category', params.category, {});
    rb.query('paymentMethod', params.paymentMethod, {});
    rb.query('gender', params.gender, {});
    rb.query('centerId', params.centerId, {});
    rb.query('childId', params.childId, {});
    rb.query('parentUserId', params.parentUserId, {});
    rb.query('isNonMember', params.isNonMember, {});
    rb.query('isMember', params.isMember, {});
    rb.query('segment', params.segment, {});
    rb.query('types', params.types, {});
    rb.query('statuses', params.statuses, {});
    rb.query('teachers', params.teachers, {});
    rb.query('validInvalids', params.validInvalids, {});
    rb.query('children', params.children, {});
    rb.query('memberRole', params.memberRole, {});
    rb.query('age', params.age, {});
    rb.query('highAge', params.highAge, {});
    rb.query('ageType', params.ageType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

lpInspectionControllerSearchAll.PATH = '/api/lp-inspection/search/all';
